import { useEffect, useState, useRef } from 'react'
import { FieldRenderProps } from 'react-final-form'
import useAdminpoly, { Lookup } from '../../playground/hooks/useAdminpoly'
import Dropdown from '../../control/Dropdown'

type DistrictInputProps = FieldRenderProps<any, HTMLElement> & {
    provinceID: number | string
}

const DistrictInput: React.FC<DistrictInputProps> = ({ input, meta, provinceID, ...rest }) => {
    const { callServiceAdminpoly } = useAdminpoly()
    const [list, setList] = useState<Lookup[]>([])

    const provID = useRef<number | string>()
    useEffect(() => {
        if (!provID.current) provID.current = provinceID
        else if (provinceID !== provID.current) {
            provID.current = provinceID
            input.onChange(null)
        }
    }, [provinceID])

    useEffect(() => {
        const fetch = async () => {
            if (provinceID) {
                const { result } = await callServiceAdminpoly(provinceID)
                setList(result?.data)
            } else {
                setList([])
            }
        }
        fetch()
    }, [provinceID])

    return (
        <Dropdown
            {...input}
            {...rest}
            meta={meta}
            options={list?.map((item) => ({
                value: item.id,
                label: item.name.th,
            }))}
            helperText={meta.error}
        />
    )
}

export default DistrictInput
